/* unplugin-vue-components disabled */import script from "./taskCard.vue?vue&type=script&setup=true&lang=js"
export * from "./taskCard.vue?vue&type=script&setup=true&lang=js"

import "./taskCard.vue?vue&type=style&index=0&id=53401423&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/edu-main-ui-pre/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-53401423"]])

export default __exports__